import { render, staticRenderFns } from "./surface_app.vue?vue&type=template&id=bc9b889a&scoped=true&"
import script from "./surface_app.vue?vue&type=script&lang=ts&"
export * from "./surface_app.vue?vue&type=script&lang=ts&"
import style0 from "./surface_app.vue?vue&type=style&index=0&id=bc9b889a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9b889a",
  null
  
)

export default component.exports